import Vue from 'vue'
import Router from 'vue-router'
import getTranslation from '@/locale/getTranslation'
import { setLang } from '@/utils'

//路由
import login from './modules/login'
import download from './modules/download' //下载
import serviceTrade from './modules/serviceTrade' //服贸会
import agreement from './modules/agreement' //协议
import rule from './modules/rule' //协议
import exhibitorList from './modules/exhibitorList' //PC版展商名录
import ErrorPage from './modules/error' //错误提示页
import Mail from './modules/mail' //错误提示页
import staticImg from './modules/staticImg' //错误提示页
import navigate from './modules/navigate'
Vue.use(Router)

let routes = [
  ...login,
  ...download,
  ...serviceTrade,
  ...navigate,
  exhibitorList,
  agreement,
  rule,
  ...Mail,
  ...staticImg,
  ...ErrorPage,
  {
    path: '/apple-app-site-association',
    redirect: '/public/apple-app-site-association'
  },
  {
    path: '/certificate/detail',
    component: () => import('@/views/certificate/detail'),
    meta: {
      title: getTranslation('查询是否可进场状态')
    },
    hidden: false
  },
  {
    path: '/message',
    component: () => import('@/views/message/list'),
    meta: {
      title: getTranslation('消息中心'),
      keepAlive: true
    },
    hidden: false
  },
  {
    path: '/message/detail',
    component: () => import('@/views/message/detail'),
    meta: {
      title: getTranslation('消息中心')
    },
    hidden: false
  },
  {
    path: '/adintoutiao',
    component: () => import('@/views/ad-toutiao'),
    meta: {
      title: getTranslation('消息中心')
    },
    hidden: false
  },
  {
    path: '/exhibition',
    component: () => import('@/views/exhibition'),
    meta: {
      title: getTranslation('展区导览')
    },
    hidden: true
  },
  {
    path: '/waiting',
    component: () => import('@/views/waiting'),
    hidden: true
  },
  {
    path: '/maintain',
    component: () => import('@/views/maintain'),
    hidden: true,
    meta: {
      title: getTranslation('系统维护中')
    }
  },
  {
    path: '/error',
    component: () => import('@/views/Error'),
    hidden: true
  },
  {
    path: '/',
    redirect: '/login',
    hidden: true
  },
  //错误路由地址处理跳转
  { path: '*', redirect: '/error' }
]

const router = new Router({
  mode: 'history',
  routes: routes
})

router.beforeEach((to, from, next) => {
  const lang = to.query.lang
  if (lang !== undefined) {
    const alias = {
      cn: 'zh-CN',
      en: 'en-US',
      ru: 'ru-RU'
    }
    setLang(alias[lang])
    console.log(to.meta)
    if (to.meta.title) document.title = to.meta.title
  }
  next()
})

export default router
